<template>
  <div class="mt-5">
    <CRow style="background-color: transparent !important;height:190px">
      <transition appear name="slide" type="animation">
        <CCard style="width: 220px; height: 235px;margin-left: 15px;top: -48px">
          <CCardHeader class="pb-0">
            <!-- display meatball icon -->
            <CRow>
              <CCol>
                <div
                  v-if="this.$store.getters['auth/userStatus']"
                  @click="showMenu"
                  class="straigtMenu"
                >
                  <i class="fa fa-ellipsis-h fa-2x" color="#B3B3B3" />
                </div>
              </CCol>
            </CRow>

            <!-- display title -->
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol
                class="subtitle card-titles"
                v-if="data.title != ''"
                @click="sendCourseData(data)"
              >{{data.title[0].val}}</CCol>
            </CRow>
            <!-- for click area -->
            <div @click="sendCourseData(data)">
              <!-- display fullname -->
              <CRow>
                <CCol>
                  <p
                    v-if="data.name[0].val != ''"
                    style="font-size: 1.5rem; margin-bottom: 0.5rem; font-weight: bold; overflow: hidden;text-overflow: ellipsis;font: Bold 16px/21px Roboto;color:white"
                  >{{data.name[0].val}}</p>
                </CCol>
              </CRow>

              <!-- display  study hrs-->
              <CRow>
                <CCol class="description">Study hours</CCol>
                <CCol class="text-right description">{{data.studyHour}}</CCol>
              </CRow>

              <!-- display Category -->
              <CRow>
                <CCol class="description">Category</CCol>
                <div v-if="data.categorys !== null">
                  <CCol
                    class="text-right description"
                    style="overflow: hidden;text-overflow: ellipsis;"
                  >
                    {{categoryName}}
                    <br />
                    <br />
                  </CCol>
                </div>
              </CRow>

              <!-- display views -->
              <CRow>
                <CCol class="description">views</CCol>
                <CCol class="text-right description">
                  <div v-if="data.views">{{data.views.length}}</div>
                  <div v-else>0</div>
                </CCol>
              </CRow>
            </div>
          </CCardBody>
        </CCard>
      </transition>

      <!-- display menu -->
      <transition name="slide" type="animation">
        <div v-show="showingMenu" style="margin-top: -45px;">
          <div v-for="(item, index) in menu" :key="index">
            <span
              v-c-tooltip.click.hover="{
                      content: item.name,
                      placement: 'right',
                      }"
              @click="clickIcon(item.name)"
              class="fav-star mr-4"
            >
              <i
                :class="item.icon"
                :color="item.color"
                style="height: 16px; width: 16px; margin-top: 0.95rem;"
              />
            </span>
          </div>
        </div>
      </transition>
    </CRow>
  </div>
</template>
<script>
export default {
  data() {
    return {
      courseTitle: "",
      categoryName: "",
      isVisible: false,
      showingMenu: false,
      value: 60,
      max: 100,
      menu: [
        {
          name: "star",
          status: false,
          color: "#FFBB00",
          icon: "fas fa-star",
        },
        // {
        //   name: "overview",
        //   status: false,
        //   color: " #6868FF",
        //   icon: "fas fa-eye"
        // },
        // {
        //   name: "progress",
        //   status: false,
        //   color: "#58C958",
        //   icon: "fas fa-flag"
        // },
        /*
        {
          name: "share",
          status: false,
          color: "#6767FF",
          icon: "fas fa-share-square",
        },
        */
        // {
        //   name: "unenrolled",
        //   status: false,
        //   color: "#FF5050",
        //   icon: "fas fa-ban"
        // }
      ],
    };
  },
  props: {
    data: Object,
  },
  mounted() {
    this.userProfile = this.$store.getters["userProfileGetter"];
    this.checkLanguage();
  },
  methods: {
    checkLanguage() {
      if (this.data.title) {
        for (let index = 0; index < this.data.title.length; index++) {
          const TitleName = this.data.title[index];
          if (TitleName.key == "en") {
            this.courseTitle = TitleName.val;
            // ลูบ key เพื่อให้แสดงภาษา ENG of title
          }
        }
      }
      if (this.data.categorys) {
        for (let index = 0; index < this.data.categorys.length; index++) {
          const element2 = this.data.categorys[index];
          const element3 = element2.category.title;
          for (let index2 = 0; index2 < element3.length; index2++) {
            const categoryss = element3[index2];
            if (categoryss.key == "en") {
              this.categoryName = categoryss.val;
              // ลูบ key เพื่อให้แสดงภาษา Eng of category
            }
          }
        }
      }
    },

    sendCourseData(data) {
      let courseCodeData = {
        courseCode: data.code,
        objectId: data._id,
      };
      this.$store.commit("dataCourse", courseCodeData);
      this.$router.push({
        name: "Overview",
        params: {
          courseCode: this.data.code,
          courseID: this.data._id,
        },
      });
    },
    showMenu() {
      this.showingMenu = !this.showingMenu;
    },
    clickIcon(icon) {
      if (icon == "star") {
        let payload = {
          course_id: this.data._id,
          user_id: this.userProfile._id,
        };
        this.$store.dispatch("deleteFavoutiteCourse", payload);
      }
    },
  },
};
</script>

<style scoped>
.fav-star {
  border-radius: 50%;
  padding-left: 0.3rem;
  padding-right: 0.3rem;
  padding-top: 0.3rem;
  padding-bottom: 0.3rem;
  background: #fff;
  margin-left: -1em;
  box-shadow: 1px 1px 2px black;
  cursor: pointer;
}
.fav-star:hover {
  background: #ececec;
}
.card {
  box-shadow: 5px 5px 10px #0000004d;
  background-color: #2a4388;
  border: white;
  border-radius: 40px;
  background: #bd2531 0% 0% no-repeat padding-box;
  transition: transform 0.2s;
  height: 100%;
  width: 210px;
  margin-right: 1.5rem;
}
.card:hover {
  /*background-color: red;*/
  cursor: pointer;
}
.card-header {
  background-color: transparent;
  border: none;
  padding-top: 0px;
}

.card-body {
  padding: 0rem 1rem;
}

.straigtMenu {
  z-index: 999;
  margin-right: -0.3rem;
  position: absolute;
  background: white;
  height: 40px;
  width: 57px;
  text-align: end;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0px 40px;
}

.straigtMenu:hover {
  /* -webkit-filter: brightness(70%); */
  filter: brightness(70%);
}

.progressBar {
  width: 9rem;
  height: 43px;
  border-radius: 50px;
  box-shadow: none;
  padding: 5px;
  overflow: visible;
}

.overviewIcon:hover {
  /* -webkit-filter: brightness(70%); */
  filter: brightness(0.4);
}

.description {
  font-size: 0.875rem;
  color: white;
}

/* -- ---------------------------------------------------------- CSS MODAL -------------------------------------------------- -- */

.closeButton {
  align-content: flex-end;
  float: right;
  width: 26px;
  height: 26px;
  padding-top: -100px;
  margin-right: 12px;
  cursor: pointer;
  margin-bottom: 0.1em;
}

.button {
  outline: none;
  border: none;
  width: 12rem;
  text-align: center;
  padding-top: 5px;
  padding-bottom: 5px;
  border-radius: 40px;
  font-size: 16px;
  margin: 10px;
}

.drobdown_modal {
  width: 90%;
  border: 0px;
  border-bottom: 1px solid #cccccc;
  margin-left: 20px;
}

.modal-text p {
  font-weight: 300;
  font-size: 16px;
  color: black;
  margin-bottom: 0px;
}

.modal-text h1 {
  font-family: "Roboto", sans-serif;
  font-weight: 600;
  font-size: 24px;
  color: black;
  text-align: center;
}

.modal-content p {
  font-size: 24px;
  margin-top: 0.6em;
}

.tab {
  border-top-right-radius: 30px;
  border-top-left-radius: 30px;
  border-bottom-right-radius: 30px;
  border-bottom-left-radius: 30px;
}

.widthLoginModal {
  width: 420px;
  position: inherit;
}

.slide-enter {
  opacity: 0;
}

.slide-enter-active {
  transition: opacity 0.4s;
  animation: slide-in 0.4s ease-out forwards;
}
.hvr-grow {
  display: inline-block;
  vertical-align: middle;
  transform: translateZ(0);
  box-shadow: 0 0 1px rgba(0, 0, 0, 0);
  backface-visibility: hidden;
  -moz-osx-font-smoothing: grayscale;
  transition-duration: 0.3s;
  transition-property: transform;
}

.hvr-grow:hover,
.hvr-grow:focus,
.hvr-grow:active {
  transform: scale(1.03);
}

/* .slide-leave {
} */

.slide-leave-active {
  transition: opacity 0.4s;
  opacity: 0;
  animation: slide-out 0.4s ease-in forwards;
}
.subtitle {
  text-align: left;
  font: Bold 70px/92px Roboto;
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 1;
}

@keyframes slide-in {
  from {
    transform: translateX(-1.5rem);
  }
  to {
    transform: translateX(0rem);
  }
}

@keyframes slide-out {
  from {
    transform: translateX(0rem);
  }
  to {
    transform: translateX(-1.5rem);
  }
}
</style>
